export const STATUS = {
  CREATED: "created",
  REQUESTED_BY_USER: "requested",
  APPROVED_BY_DEPT_HEAD: "by_department",
  REJECTED: "rejected",
  APPROVED_BY_DIRECTOR: "by_director",
  APPROVED_BY_F_N_A: "approved",
};

export const STATUS_LABELS = {
  created: "Created By User",
  requested: "Requested By User",
  by_department: "Approved by Department Head",
  by_director: "Approved by Director",
  approved: "Approved by F&A",
  rejected: "Rejected",
};
